<template>
    <div>
        <!-- Modal -->
        <b-modal id="linkModal" title="Link del documento" size="xl" centered scrollable header-bg-variant="dark"
            v-model="modalShow">

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>

            </template>

            <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

            <!-- cuerpo de cart -->
            <DocumentPdf :pdfUrl="link"></DocumentPdf>

            <!-- fooder -->
            <template #modal-footer>
                <div
                    v-permission="'documentos-ver-documento'"
                    class="w-100"
                >
                    
                    <DocumentVisit :documentId="documentId"></DocumentVisit>
                    
                </div>
            </template>

        </b-modal>
    </div>
</template>
<script>
import { EventNames } from '@/plugins/enums/index.js'
import DocumentPdf from '@/components/shared/Document-pdf.vue'
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import DocumentVisit from '@/components/DocumentRepository/DocumentLink/Document-visit.vue'

export default {
    name: 'DocumentLink',

    data() {
        return {
            modalShow: false,
            documentRouter: '',
            link: '',
            documentId: ''
        }
    },

    components: {
        DocumentPdf,
        AlertDismiss,
        DocumentVisit
    },

    async mounted() {
        this.$eventBus.$on(EventNames.OpenModalDocumentLink, async (query) => {
            this.reset();
            this.openModal();

            this.documentRouter = query[0].route;
            this.documentId = query[0].id;

            await this.getLinkDocumento();
        });
    },

    methods: {
        ...mapActions(["getUrl"]),

        reset(){
            this.documentRouter = '';
            this.link = '';
            this.documentId = '';
        },

        openModal() {
            this.modalShow = true;
        },

        closeModal() {
            this.modalShow = false;
        },

        async getLinkDocumento() {
            let result = await this.getUrl({ route: this.documentRouter });

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }

            this.link = result.data;

        }
    }
}
</script>
<style></style>